import React, { useRef, useEffect } from "react";
import styles from "./InputDesign.module.css";
import Menu from "../../player/overlay/stickers/Menu";
import { useState } from "react";
import { PlayerContext } from "../../player/PlayerContext";
import Sticker from "../../player/overlay/stickers/Sticker";
import { StickerContext } from "../../player/StickerContext";

function PreviewArea (props){
  const previewRef = useRef(null);
  const [windowDimensions, setWindowDimensions] = useState({width: 360, height: 720});
  const [storyDimensions, setStoryDimensions] = useState({containerWidth: 360, containerHeight: 720});
  const [sizeMultiplier, setSizeMultiplier] = useState(1);
  const [playMode, setPlayMode] = useState("preview");

  useEffect(() => {
    const updateDimensions = () => {
      if (previewRef.current) {
        const containerWidth = previewRef.current.parentElement.clientWidth;
        const containerHeight = previewRef.current.parentElement.clientHeight;
        
        // Calculer le multiplicateur de taille en fonction de l'espace disponible
        const widthScale = (containerWidth - 32) / 360; // 32px pour les marges
        const heightScale = (containerHeight - 32) / 720;
        const scale = Math.min(widthScale, heightScale, 1); // Ne pas dépasser la taille originale
        
        setSizeMultiplier(scale);
        setWindowDimensions({ width: 360, height: 720 });
        setStoryDimensions({ containerWidth: 360, containerHeight: 720 });
      }
    };

    // Mise à jour initiale
    updateDimensions();

    // Mise à jour lors du redimensionnement de la fenêtre
    window.addEventListener('resize', updateDimensions);

    // Nettoyage
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);    

  return (
    <section 
      ref={previewRef} 
      className={styles.previewArea}
      style={{
        width: '360px',
        height: '720px',
        minWidth: '360px',
        minHeight: '720px',
        maxWidth: '360px',
        maxHeight: '720px',
        borderRadius: '16px',
        overflow: 'hidden',
        transform: `scale(${sizeMultiplier})`,
        transformOrigin: 'top left',
        margin: '16px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
      }}
    >
      <PlayerContext.Provider value={new Map([
        ["windowDimensions", windowDimensions], 
        ["storyDimensions", storyDimensions], 
        ["sizeMultiplier", sizeMultiplier],
        ["menuColor", "#2ec5b3"], 
        ["playMode", playMode]
      ])}>   
      <StickerContext.Provider value={new Map([
        ["menuTitleFont", props.styleSettings.titleFont.name],
        ["menuTextFont", props.styleSettings.textFont.name],
      ])}>               
        <Menu 
          show={true} 
          storyId={""} 
          story={{menuStyle: 'custom', primaryColor: "#2ec5b3"}} 
          editorPages={props.pages.length > 0 ? props.pages : null}
          editorMenu={props.styleSettings}
          fromMaker={true} 
          fromMenuEditor={true}
          snackSwipeAlreadyDisplayed={true} 
          setSnackSwipeAlreadyDisplayed={()=>{}} 
          closeMenu={()=>{}}
        />
        </StickerContext.Provider>
      </PlayerContext.Provider>
    </section>
  );
};

export default PreviewArea;
